import {
    Flex,
    Button,
    Text,
    InputGroup,
    Select,
    Heading,
    SVGs,
    SVG,
} from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { AdminCancelBookTemplateProps } from './admincancelbook.props'
import StyledAdminCancelBook from './admincancelbook.styles'
import { FeeSize, OnBehalfOf } from '@raskrask-dk/bookingflow-state-machine'

export const AdminCancelBookTemplate = ({
    settingsHandler: {
        setCancellationFeeSize,
        shouldSendCustomerMessages,
        setShouldSendCustomerMessages,
        shouldSendPartnerMessages,
        setShouldSendPartnerMessages,
        shouldCloseTime,
        setShouldCloseTime,
        cancelOnBehalfOf,
        setCancelOnBehalfOf,
        cancelReason,
        setCancelReason,
    },
    ctaHandle: { isDisabled, onClickCta },
    adminSectionHandle: { shouldShowAdminSection },
    feeSizeOptions,
    feeValue,
    bookingId,
}: AdminCancelBookTemplateProps): ReactElement => {
    const otherSettings = (
        <Flex direction={'column'} gap={16}>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Should close old time</Text>
                <InputGroup
                    data-cy="should-close-time"
                    type={'checkbox'}
                    checked={shouldCloseTime}
                    onChange={(e) => setShouldCloseTime(e.target.checked)}
                />
            </Flex>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Cancel on behalf of</Text>
                <Select
                    data-cy="cancel-on-behalf-of"
                    value={{ label: cancelOnBehalfOf, value: cancelOnBehalfOf }}
                    options={[
                        { label: 'Customer', value: 'Customer' },
                        { label: 'Partner', value: 'Partner' },
                    ]}
                    onChange={(e) =>
                        setCancelOnBehalfOf(e!.value as OnBehalfOf)
                    }
                />
            </Flex>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Reason:</Text>
                <InputGroup
                    data-cy="cancel-reason"
                    type={'text'}
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                />
            </Flex>
        </Flex>
    )

    const cancellationFee = (
        <Flex direction={'column'} gap={16}>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Fee</Text>
                <Select
                    data-cy="cancellation-fee-size"
                    options={feeSizeOptions}
                    value={feeValue}
                    onChange={(e) =>
                        setCancellationFeeSize(parseInt(e!.value) as FeeSize)
                    }
                />
            </Flex>
        </Flex>
    )

    const cancellationMessages = (
        <Flex direction={'column'} gap={16}>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Send cancellation messages to customer</Text>
                <InputGroup
                    data-cy="send-cancellation-messages-to-customer"
                    type={'checkbox'}
                    checked={shouldSendCustomerMessages}
                    onChange={(e) =>
                        setShouldSendCustomerMessages(e.target.checked)
                    }
                />
            </Flex>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Send cancellation messages to partner</Text>
                <InputGroup
                    data-cy="send-cancellation-messages-to-partner"
                    type={'checkbox'}
                    checked={shouldSendPartnerMessages}
                    onChange={(e) =>
                        setShouldSendPartnerMessages(e.target.checked)
                    }
                />
            </Flex>
        </Flex>
    )

    const ctaButton = (
        <Button
            data-cy="continue-button"
            variant={'default'}
            size={'large'}
            endIcon={<SVG src={SVGs.ChevronRight} />}
            disabled={isDisabled}
            onClick={onClickCta}
        >
            Continue
        </Button>
    )

    return (
        <StyledAdminCancelBook>
            {shouldShowAdminSection ? (
                <>
                    <Flex direction={'row'} justifyContent={'center'}>
                        <Flex
                            direction={'column'}
                            gap={16}
                            css={{
                                p: '$4 $3',
                                bgc: '$white',
                                border: '1px solid $neutral200',
                                height: '100%',
                                width: '500px',
                            }}
                        >
                            <Heading>Cancel Booking</Heading>
                            <Flex
                                direction={'row'}
                                justifyContent={'space-between'}
                            >
                                <Text color={'primary300'}>{bookingId}</Text>
                            </Flex>
                            {cancellationMessages}
                            {cancellationFee}
                            {otherSettings}
                            <Flex gap={16} justifyContent={'flex-end'}>
                                {ctaButton}
                            </Flex>
                        </Flex>
                    </Flex>
                </>
            ) : (
                <></>
            )}
        </StyledAdminCancelBook>
    )
}
